import React, { memo } from "react";
import { Box, Center, Spinner } from "@chakra-ui/react";
import ReactPlayer from "react-player";
import colors from "app/colors";
import { AudioFileIcon } from "modules/icons";
import { IMAGE_GALLERY_ITEM_MAX_HEIGHT } from "modules/utils/Constants";

interface IProps {
  fileUrl?: string | null;
  isAudio: boolean;
  isActive?: boolean;
}

const FileVideoPlayer = ({ fileUrl, isAudio, isActive = true }: IProps) => {
  if (!fileUrl) {
    return <Spinner />;
  }

  // Only play the video if it is active

  return (
    <Box
      color={colors.blue}
      w="full"
      h="full"
      maxH={IMAGE_GALLERY_ITEM_MAX_HEIGHT}
    >
      {isAudio && (
        <Center>
          <AudioFileIcon boxSize={1000} />
        </Center>
      )}
      <ReactPlayer
        playing={isActive}
        controls
        url={fileUrl}
        width="100%"
        height="100%"
        config={{
          file: {
            attributes: {
              style: {
                width: "100%",
                height: "100%",
                objectFit: "contain",
              },
            },
          },
        }}
      />
    </Box>
  );
};

export default memo(FileVideoPlayer);
